export default {
  paidOut: "(Uitbetaald)",
  product: "Prodotto",
  quantity: "Quantità",
  attributes: "Attributi",
  points: "Punti",
  point: "Punto",
  action: "Azione",
  clear: "Cancellare",
  back: "Indietro",
  save: "Salvare",
  close: "Chiudere",
  of: "Da",
  to: "A",
  copyrights: "© {date} Bridgestone Solutions. Tutti i diritti riservati.",
  pageNotFound: "Pagina non trovata",
  accessDenied: "Accesso negato",
  search: "Ricerca",
  dashboard: {
    profile: {
      welcome: "Benvenuti a",
      completeProfile: "Completate il vostro profilo personale e inoltre",
      completeProfileBold: "Assicuratevi 200 punti.",
      link: "Mostra il profilo",
      fullCompleteProfile: "Il vostro profilo personale è completo!",
    },
    pobox: {
      newMessages: "Nuovi messaggi nella casella di posta elettronica",
      link: "Notizie",
    },
    bankstatement: {
      yourScore: "Il vostro punteggio attuale:",
      lastUpdate: "Ultimo aggiornamento:",
      link: "Mostra la panoramica dei punti",
      kickbackLink: "Panoramica delle commissioni kickback",
      yourKickback: "Il vostro numero attuale di commissioni di kickback:",
    },
    showAllProducts: "Al negozio dei premi",
  },
  pageName: {
    productInfoAndQuestions: "Brochure e Listini prezzi",
    preislisten: "Brochure e Listini prezzi",
    preislistenList: "Listini prezzi",
    dashboard: "Pagina principale",
    trainings: "Corsi di formazione",
    onlineTrainings: "Corsi di formazione online",
    bridgestoneSchulungen: "Corsi di formazione Bridgestone",
    shop: "Negozio a premi",
    shopProducts: "Negozio a premi",
    shopCategory: "Negozio a premi",
    product: "Prodotto",
    productDetails: "Dettagli del prodotto",
    productInfo: "Informazioni sul prodotto",
    pkw: "Auto",
    motorrad: "Motocicletta",
    lkwUndBusse: "Camion e autobus",
    produktbroschuren: "Brochure di prodotto",
    pricat: "Prezzo",
    landwirtschaft: "Agricoltura",
    baumaschinenOtr: "Macchine da costruzione - Otr",
    bDrive: "Immagini e loghi di pneumatici",
    beanstandungsFormular: "Modulo di reclamo",
    bridgestoneProduktbroschuren: "Prodotti Bridgestone",
    firestoneProduktbroschuren: "Prodotti Firestone",
    technologien: "Tecnologie, marcature e altro ancora",
    training: "Formazione",
    trainingForm: "Modulo di formazione",
    account: "Il mio account",
    pointsOverview: "Il mio conto punti",
    stammdaten: "I miei dati anagrafici",
    mailbox: "Casella postale",
    singleMailbox: "Messaggio",
    bridgestoneSingleSchulungen: "Corsi di formazione Bridgestone",
    externeTraining: "Corsi di formazione esterni",
    warenkorb: "Cestino della spesa",
    orderSummary: "Panoramica dell'ordine",
    orderDelivery: "Indirizzo di consegna",
    orderComplete: "Ordine andato a buon fine",
    text_page: "Pagina statica",
    contact_service: "Contatti e assistenza",
    sales_support: "Assistenza alle vendite",
    salesPromotions: "Promozione delle vendite",
    productInfoAndPriceList: "Informazioni sui prodotti e listini prezzi",
    service_number: "Numeri di servizio",
    about: "Informazioni su BRIDGESTONE PLUS",
    contact_form: "Modulo di reclamo",
    userOrders: "I miei ordini",
    userOrder: "Il vostro ordine",
    hunterShop: "Hunter",
    wholesaler: "Cruscotto dei partner strategici",
    news_feeds: "Ultime notizie",
    investment: "Sostegno agli investimenti",
    staff: "Cruscotto",
    fuelCalculator: "Calcolatore del risparmio di carburante",
    myAccount: "Il mio account",
    myPoints: "I miei ordini di pneumatici",
    commitmentLetter: "Lettera di impegno",
    rewardsOverview: "Spiegazione della commissione kickback e dei punti",
    strategic_partners: "Contattare il partner di vendita",
    onlineVisibility: "Ovunque",
    media: "Pacchetti multimediali",
    staffVouchers: "Vouchercodes",
    wholesalerVouchers: "Vouchercodes",
    brochure_prices: "Brochure prodotti e listini prezzi",
    touch_incentive: "Contact Touch Incentive",
    favoriteProducts: "Prodotti preferiti",
  },
  account: {
    title: "Il mio account",
    desc: "Benvenuti nella vostra area personale. Qui potete aggiungere i vostri dati anagrafici o personalizzare il sito <br/>, visualizzare la vostra casella di posta elettronica e l'estratto conto dei punti.",
    descStaff:
      "Benvenuti nella vostra area personale. Qui potete aggiungere i vostri dati anagrafici o personalizzare il sito <br/>, visualizzare la vostra casella di posta elettronica e l'estratto conto dei punti.",
    categories: {
      basedata: {
        title: "Dati anagrafici",
        desc: "Per una partecipazione di successo, completare qui i dati di contatto e dell'azienda.",
      },
      pobox: {
        title: "Casella postale",
        desc: "Nella vostra casella di posta elettronica personale troverete messaggi importanti, conferme d'ordine e novità.",
      },
      bankstatement: {
        title: "Estratto conto bancario",
        desc: "Qui è possibile visualizzare il saldo attuale dei punti premio e i movimenti del conto.",
      },
    },
  },
  profile: {
    title: "I miei dati anagrafici",
    description:
      "Benvenuti nella vostra area personale. Qui potete aggiungere o modificare i vostri dati anagrafici, visualizzare la vostra casella di posta elettronica e l'estratto conto dei punti.",
    personalData: "Dati personali",
    password: "password",
    password1: "Password (liberamente selezionabile)*",
    password2: "Password (ripetizione)*",
    formOfAddress: "Titolo",
    choose: "Selezionare",
    mr: "Signore",
    mrs: "Signora",
    diverse: "Varie",
    firstname: "Nome",
    surname: "Cognome",
    position: "Posizione in azienda",
    operatingData: "Dati operativi",
    company: "Azienda",
    legalForm: "Forma giuridica",
    name: "Nome",
    streetHouseNr: "Via e numero civico.",
    street: "Via",
    postcode: "CAP",
    location: "Luogo",
    country: "Paese",
    de: "Germania",
    at: "Austria",
    ch: "Svizzera",
    nl: "Paesi Bassi",
    it: "Italia",
    language: "Lingua",
    french: "Francese",
    italian: "Italiano",
    german: "Germania",
    nederland: "Paesi Bassi",
    phone: "Telefono",
    website: "Sito web",
    operatingIndicators: "Principali dati operativi",
    tireSale: "Vendite di pneumatici all'anno circa in pezzi.",
    tireSaleLabel: "Vendere pneumatici in grandi quantità",
    inches: "Di cui ≥ 18 pollici (in %)",
    inchesLabel: "Di cui 18 pollici e più in %",
    segmentSale:
      "Vendite di pneumatici per segmento (quota Budget / Mid / Premium in %)",
    premBudget: "Premio",
    midBudget: "Medio",
    budBudget: "Bilancio",
    distribution: "DISTRIBUZIONE ESTATE / INVERNO / TUTTA LA STAGIONE (in %)",
    tyreSizes: "Numero di pneumatici stoccati per stagione (set di pneumatici)",
    diffDeliveryAddres: "Aggiungere indirizzo di consegna",
    yourEmailAddress: "Il vostro indirizzo e-mail*",
    clientNr: "Numeri clienti",
    clientNrSingular: "Numero cliente",
    clientNrContent:
      "<span class='text-danger fw-bold'>IMPORTANTE - SI PREGA DI LEGGERE:</span><br /><br /> Per l'assegnazione degli ordini di pneumatici presso i grossisti e/o Bridgestone, è <b>essenziale inserire i rispettivi numeri di cliente</b>.<br/><br/>Se si <b>dispone di più numeri di cliente presso un grossista e/o Bridgestone,</b> ad esempio per il negozio principale e le filiali, inserire prima il numero di cliente del negozio principale.<br/><br/><b>Le vendite degli altri numeri di cliente vengono quindi assegnate al negozio principale</b>.",
    supplySource: "Fonte di approvvigionamento",
    email: "Indirizzo e-mail",
    staffEmail: "Indirizzo e-mail del partecipante",
    registered: "Registrato il",
    registeredAt: "Registrato il",
    lastLogIn: "Ultimo accesso",
    details: "dettagli",
    inDetail: "{name} in dettaglio",
    bsClientNr: "Il vostro numero cliente Bridgestone",
    bftClientNr: "Il vostro numero cliente Best4Tires",
    acceptTerms: "Accettare i termini e le condizioni di partecipazione.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>IMPORTANTE - LEGGERE:</span><br />Quando si inserisce il proprio numero cliente per la prima volta, i dati vengono controllati per verificarne l'accuratezza e i criteri di vendita. La decisione di attivare il/i codice/i cliente/i e di collegarlo/i al suo profilo può richiedere fino a 5 giorni lavorativi.",
    selectWholeSaler: "presso il fornitore (selezionare)",
    cooperation: "MEMBRO / COOPERAZIONE",
    error100: "La somma dei valori deve essere pari al 100%.",
    errorRange: "Il valore deve essere compreso tra 0 e 100",
    btw_number_label:
      "Numero di identificazione dell'imposta sulle vendite della vostra azienda",
    btw_number: "Numero di identificazione dell'imposta sulle vendite",
    mobile: "NUMERO DI CELLULARE",
    mobile_label: "Il vostro numero di telefono (cellulare)",
    iban_number: "Numero IBAN DELLA VOSTRA IMPRESA",
    iban_number_label: "Numero IBAN",
    yourCsNr: "I vostri numeri di clienti",
    yourLastName: "Il vostro cognome",
    positionLabel: "Selezionare la posizione",
    yourFirstName: "Il vostro nome",
    companyLabel: "Azienda",
    numberOfSetsOfSeasonalTiresBudget: "Stoccaggio all'anno",
    contactInfo: "In caso di domande, contattare:",
  },
  pobox: {
    title: "La mia cassetta della posta",
    desc: "Benvenuti nella vostra area personale. Qui potete aggiungere o modificare i vostri dati anagrafici, visualizzare la vostra casella di posta elettronica e l'estratto conto dei punti.",
    message: {
      sender: "Mittente",
      thread: "Oggetto",
    },
    sender: {
      system: "BRIDGESTONE PLUS",
    },
    back: "Torna alla panoramica",
  },
  time: {
    secondsAgo: "{time} secondi fa",
    minutesAgo: "{time} minuti fa",
    hoursAgo: "{time} ore fa",
    daysAgo: "{time} giorni fa",
  },
  bankstatement: {
    title: "L'estratto conto personale",
    desc: "Qui è possibile visualizzare l'estratto conto personale di Bridgestone Plus per i punti premio ricevuti e utilizzati. Si noti che i punti per l'ordine di pneumatici saranno accreditati solo fino a 6 settimane dopo la data dell'ordine, a seconda della fonte di approvvigionamento.",
    score: "Punteggio",
    regularPoints: "Punti regolari",
    boosterPoints: "Punti di richiamo",
    date: "data",
    supplySourceReason: "Fonte di approvvigionamento / motivo",
    article: "Articolo",
    brand: "Marchio",
    product: "Prodotto",
    type: "Tipo",
    inch: "Dogana",
    season: "Stagione",
    amount: "Quantità",
    standardPoints: "Punti",
    boosterProduct: "Prodotto booster",
    boosterSeason: "La stagione del Booster",
    otherActions: "Altre azioni o cause",
    totalPoints: "Punti totali",
    income: "Aggiunte",
    spending: "Partenze",
    lastMonth: "Stato finale",
    loadMore: "Carica altri 20 turnovers",
    typeFilter: "Filtrare per fonte di approvvigionamento",
    dateFilter: "Filtrare per intervallo di date",
    customer_number: "Numero cliente",
    currentPoints: "Punti attuali",
    calculationDate: "Data di calcolo",
    positivePoints: "Punti positivi",
    negativePoints: "Già emesso",
    tyresAmount: "Pneumatici Quantità annuale",
    pointsTotal: "Punteggio totale",
    currentPointState: "Punteggio attuale",
    currentKickbackState: "kickback attuale",
    pointsFromCurrentYear: "Aggiunta: punti dell'anno corrente ({year})",
    pointsAtRiskOfExpiry: "Punti da spendere entro il 31.03.{year}",
  },
  shop: {
    variant: "Varianti selezionabili",
    description:
      "Benvenuti nel negozio dei premi. Qui è possibile riscattare i punti Bridgestone Plus <br/> per ottenere premi di varie categorie. La gamma di prodotti <br/> viene aggiornata regolarmente. Ci auguriamo che la navigazione sia piacevole.",
    selectedProducts: "Prodotti selezionati",
    selectedAddress: "Indirizzo selezionato",
    noProducts: "I criteri di ricerca non hanno restituito alcun risultato",
    placeOrder: "Ordine vincolante",
    toOrderDelivery: "Proseguire con l'indirizzo di consegna",
    toOrderSummary: "Alla panoramica degli ordini",
    emptyCart: "Il carrello è vuoto.",
    pointsTotal: "Punti totali",
    productImg: "Immagine del prodotto",
    selectAddressBtn: "Selezionare l'indirizzo",
    selectAddressP: "Selezionare l'indirizzo di consegna",
    notEnoughPoints: "Non ci sono abbastanza punti disponibili.",
    outOfStock: "Attualmente non disponibile",
    timeUnavailable: "Attualmente non disponibile",
    productUnavailable: "Questo prodotto non è più disponibile.",
    deletedProductsTitle: "Prodotti non più disponibili",
    deletedProductsMessage:
      "I seguenti prodotti non sono più disponibili. Rimuovili dal carrello per continuare.",
    removeSelected: "Rimuovi selezione",
    clearCart: "Svuota carrello",
    removeSelectedConfirm: "Rimuovere i prodotti selezionati dal carrello?",
    clearCartConfirm: "Rimuovere tutti i prodotti dal carrello?",
    cart: {
      pointsPerUnit: "Punti / unità",
      pointsSum: "Punti",
    },
    sort: {
      asc: "Ordina per: Prezzo più basso",
      desc: "Ordina per: Prezzo più alto",
    },
    perPgae: "Elementi per pagina",
    categories: {
      advertising: {
        title: "Materiale pubblicitario",
        desc: "Partecipate direttamente qui sulla piattaforma e assicuratevi <br/> 40 punti extra per il club dei premi.",
      },
      rewards: {
        title: "Premi esclusivi",
        desc: "Scoprite la gamma di premi su <br/>il nostro centro di formazione o presso la vostra sede.",
      },
      tools: {
        title: "Strumenti per l'officina",
        desc: "Utilizzate i vostri punti per la formazione di terzi <br/> e riducete i costi.",
      },
      trainings: {
        title: "Formazione e istruzione",
        desc: "Scoprite la gamma di premi nel nostro centro di formazione o presso la vostra sede.",
      },
      salesroom: {
        title: "Sala vendite",
        desc: "Allestire la scena nel vostro locale di vendita e offrire ai vostri clienti un soggiorno piacevole.",
      },
      hunter: {
        title: "Hunter",
        desc: "Scambiate i punti con interessanti attrezzature da officina Hunter.",
      },
    },
    bestSold: "I più acquistati",
    seasonal: "Stagionale",
    affordable: "Ci siamo quasi",
    forPoints: "per {points} punti",
    reachedPoints: "Punteggio richiesto raggiunto",
    cartRemainPoints: "Punti rimanenti",
    remainingPoints: "{points} Punti rimanenti",
  },
  externeTraining: {
    title: "Corsi di formazione esterni",
    description:
      "Assicuratevi le conoscenze degli esperti e, se completate con successo i rispettivi test di formazione, il vostro certificato di partecipazione personale e 40 punti extra per il club dei premi.",
    additionalInfo:
      "Oltre ai nostri corsi di formazione online gratuiti e ai corsi di formazione Bridgestone a pagamento, vi offriamo anche la possibilità di finanziare o sovvenzionare corsi di formazione esterni con i vostri punti premio, a seconda del vostro saldo di credito.",
    itsEasy: "È così semplice:",
    excludeText:
      "Si precisa che sono escluse le offerte di concorrenza diretta.",
    downloadSection: {
      title: "Scarica il modello di fattura",
      description1:
        "Scaricate qui un modello per la vostra dichiarazione dei punti.",
      description2: "Nell'esempio troverete tutte le informazioni necessarie.",
    },
    form: {
      title: "Applicazione",
      thirdPartyInvoice: "Fattura del fornitore terzo",
      userInvoice: "La mia fattura",
      bankAccountOwner: "Titolare del conto",
      uploadInvoice: "Caricare la mia fattura per i punti utilizzati",
      have: "Vorrei",
      thirdPartyInvoiceDesc:
        "Punti in un %{calculatePriceDiscount} CHF di per quanto segue",
      userInvoiceDesc:
        "Inserire la fattura della formazione, caricare la fattura di un fornitore terzo",
    },
    info: {
      paragraph1:
        "Voi o il vostro team partecipate a un corso di formazione specializzato di un fornitore terzo.",
      paragraph2: "Il cliente salda la fattura del fornitore terzo.",
      paragraph3:
        "Potete richiedere una sovvenzione qui, su questa pagina, nel campo di richiesta.",
      elements: {
        first: "Caricare la fattura del fornitore terzo",
        second:
          "Immettere l'importo dei punti che si desidera utilizzare (importo massimo dell'importo netto della fattura).",
        third:
          "Creerete una fattura per la vostra azienda per l'importo dei punti utilizzati (0,25 CHF netti per punto) e la caricherete.",
        fourth: "Le fatture e la domanda vengono controllate",
        fifth: "Riceverete una vincita pari all'importo dei punti scommessi.",
      },
    },
    success: {
      title: "Grazie mille",
      paragraph: {
        first: "La vostra domanda è stata ricevuta.",
        second:
          "Dopo un controllo positivo, riceverete un rimborso pari all'importo dei punti utilizzati, accreditato sul conto specificato.",
        third:
          "La verifica e il pagamento possono richiedere fino a 6 settimane.",
        fourth:
          "Abbiamo ridotto il vostro conto punti della quantità di punti utilizzati.",
        fifth: "Una copia della domanda è contenuta nella vostra",
      },
    },
  },
  buttons: {
    toSearch: "Ricerca",
    sendRequest: "Invia una richiesta",
    formButton: "al modulo",
    discoverButton: "Scoprire",
    sendButton: "Inviare",
    makeContact: "Contattateci",
    userProfile: "Ai dati anagrafici",
    userOrders: "Ai vostri ordini",
    mailbox: "Alla cassetta della posta",
    pointsList: "All'estratto conto",
    next: "Ulteriori",
    back: "INDIETRO",
    skip: "Salto",
    toTheBasket: "Aggiungi al carrello",
    edit: "Modifica",
    cancel: "Annullamento",
    select: "Selezionare",
    newOrder: "Nuovo ordine",
    downloadAll: "Scaricare tutti",
    readNow: "Leggi ora",
    toDashboard: "Alla pagina iniziale",
    moreCustomerNumbers: "+ specificare ulteriori numeri di clienti",
    toProductInfo: "SCOPRI LE INFORMAZIONI SUI PRODOTTI",
    toAccount: "AL CONTO PUNTI",
    toSalesPromotions: "REGISTRA ORA LA TUA ATTIVITÀ",
    show: "SCOPRI ORA",
    toOnlineTrainings: "ALLE FORMAZIONI ONLINE",
    newAddress: "Creare un nuovo indirizzo di consegna",
    toQuiz: "Al quiz",
    toDownload: "Al download",
    calculate: "Calcolare",
    reset: "Nuovo calcolo",
    register: "Accedi",
    refuseBtn: "RIFIUTO",
    acceptBtn: "ACCETTA",
    toCommitmentLetter: "ALLA LETTERA DI IMPEGNO",
    toKickbackFeeInfo: "SPIEGAZIONE DELLA TASSA E DEI PUNTI",
    clickHere: "Vedi i dettagli",
    directBuy: "Ordina direttamente",
    toDiscover: "Scoprire",
    dealerInfoDownload: "SCARICA LE INFORMAZIONI SUL RIVENDITORE",
    all: "Tutto",
    clearFilters: "Reimpostare il filtro",
    selectAll: "Seleziona tutto",
    deselectAll: "Deseleziona",
    downloadSelection: "Scarica la selezione",
    preview: "Anteprima",
    vouchers: "Alla panoramica dei punti",
    exchangeVoucher: "Riscatta il codice voucher",
    confirm: "PER CONFERMARE",
    toFavorites: "Ai tuoi prodotti preferiti",
  },
  myAccount: "Il tuo account",
  menu: {
    account: "Il mio account",
    plus: 'Informazioni su Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Assistenza alle vendite",
    mailbox: "Casella postale",
    about: "Informazioni su BS Plus",
    trainingAndCourses: "Formazione e istruzione",
    externalTraining: "Corsi di formazione esterni",
    productInfo: "Informazioni sul prodotto",
    productBrochures: "Brochure dei prodotti",
    priceLists: "Listini prezzi",
    price: "Prezzo",
    complaintForm: "Modulo di reclamo",
    sales_support: "Assistenza alle vendite",
    contact_service: "Contatti e assistenza",
    logOut: "Disconnettersi",
    news: "Ultime notizie",
  },
  productInfo: {
    categories: {
      info: "Informazioni sul prodotto",
      priceList: "Listini prezzi",
      contact: "Contattateci",
    },
    page: {
      description:
        "Benvenuti nell'area informativa sui prodotti Bridgestone e Firestone.<br/>Qui troverete brochure e listini prezzi aggiornati, oltre a link utili e moduli.",
    },
    index: {
      title: "Informazioni sul prodotto",
      description:
        "Benvenuti nell'area informativa sui prodotti Bridgestone e Firestone.<br/>Qui troverete brochure aggiornate e materiale aggiuntivo.",
      categories: {
        productBrochures: {
          title: "Brochure dei prodotti",
          description:
            "Scarica le ultime brochure dei prodotti Bridgestone e Firestone",
        },
        bDrive: {
          title: "Immagini di pneumatici e loghi<br/>",
          description:
            "Loghi, immagini dei prodotti e modelli di marketing attuali",
          button: "PER B-DRIVE",
        },
        calculator: {
          title:
            "Calcolatore del <span class='text-danger'> risparmio di</span> carburante",
          description:
            "Pneumatici con resistenza al rotolamento ottimizzata: Calcolare facilmente il potenziale di risparmio!",
        },
        carApprovals: {
          title: "Omologazioni auto",
          description:
            "Trova i pneumatici Bridgestone per auto adatti con omologazione",
        },
        motorcycleApprovals: {
          title: "Omologazioni moto",
          description:
            "Trova i pneumatici Bridgestone per moto adatti con omologazione",
        },
        dataGenerator: {
          title: "Generatore di schede tecniche",
          description: "Inserisci l'IPC e genera la tua scheda tecnica",
        },
      },
    },
  },
  productList: {
    pkw: {
      title: "Listini prezzi dei pneumatici per auto, 4x4 e furgoni",
      description:
        "Scaricate qui i listini prezzi aggiornati dei nostri pneumatici Bridgestone e Firestone: <ul> <li>Pneumatici per auto, 4x4 e furgoni</li> </ul>",
    },
    trucksAndBuses: {
      title: "Listini prezzi per autocarri e autobus",
      description:
        "Scaricate qui i listini prezzi aggiornati dei nostri pneumatici Bridgestone e Firestone: <ul> <li>Camion e autobus</li> </ul>",
    },
    motorcycles: {
      title: "Listini prezzi dei pneumatici per moto",
      description:
        "Scaricate qui i listini prezzi attuali dei nostri pneumatici Bridgestone: <ul> <li>Moto</li> </ul>",
    },
    agriculture: {
      title: "Listini prezzi degli pneumatici agricoli",
      description:
        "Scaricate qui i listini prezzi attuali dei nostri pneumatici Bridgestone e Firestone: <ul> <li>Agricoltura</li> </ul>",
    },
    constructionMachineryOtr: {
      title: "Listini prezzi per macchine da costruzione/pneumatici OTR",
      description:
        "Scaricate qui i listini prezzi attuali dei nostri pneumatici Bridgestone e Firestone: <ul><li>Macchine edili/OTR</li></ul>",
    },
    main: {
      title: "Listini prezzi",
      description:
        "Scaricate qui i listini prezzi aggiornati dei nostri pneumatici Bridgestone e Firestone: <ul><li>Pneumatici per auto, 4x4 e furgoni</li><li>moto</li><li>Camion e autobus</li> <li>Pneumatici agricoli</li><li>Macchine edili / OTR</li></ul>",
    },
    index: {
      description:
        "Benvenuti nell'area informazioni sui prodotti Bridgestone e Firestone. Qui troverete opuscoli aggiornati, listini prezzi e file Pricat.",
    },
  },
  productBrochures: {
    desc: "Scaricate qui le brochure e i volantini attuali sui nostri pneumatici Bridgestone e Firestone per auto, SUV e furgoni.",
    technologiesTitle: "Tecnologie, marcature e altro ancora",
    technologiesDesc:
      "Scaricate qui le brochure e i volantini più recenti sulle nostre tecnologie, sulle marcature e altro ancora per auto, SUV e furgoni.",
    BDriveTitle: "Immagini e loghi di pneumatici",
    BDriveDesc:
      "Qui troverete immagini di profilo, loghi e altro ancora per tutte le aree di prodotti e i marchi da scaricare.",
    BDriveLinkText: "Link al portale ILLUSTRAZIONI DEI PNEUMATICI & LOGOS",
  },
  contact: {
    index: {
      title: "Contatti e assistenza",
      description:
        "Benvenuti nell'area di servizio BRIDGESTONE PLUS. Qui troverete i recapiti del team di assistenza e la possibilità di inviare reclami sui prodotti tramite un modulo.",
    },
    categories: {
      service: {
        description:
          "Numero di assistenza per la vostra regione e contatto e-mail",
      },
      form: {
        description:
          "Inviate i reclami sui prodotti direttamente qui, utilizzando il modulo",
      },
      touch: {
        title: "Contact Touch Incentive",
        description:
          "In caso di domande sui prodotti nel negozio di articoli da regalo Bridgestone plus, sugli ordini effettuati, sui tempi di consegna e/o sulle consegne. Si prega di contattare il fornitore esterno del negozio di articoli da regalo: Touch Incentive Rotterdam: 010 2043075 o support&#64;touchincentive.com.",
      },
    },
    form: {
      intermediaryAddress: "Indirizzo dell'intermediario",
      nameFirma: "Nome / Azienda",
      strHouseNr: "Via e numero",
      contactPerson: "Persona di contatto",
      vehicleDetails: "Dettagli del veicolo",
      vehicleTyres: "Veicolo/pneumatici*",
      brandNew: "Nuovo (non assemblato)",
      newItem: "Nuovo (assemblato)",
      fwd: "Trazione anteriore",
      rwd: "Trazione posteriore",
      awd: "Trazione integrale",
      vehicleManufacturer: "Costruttore del veicolo",
      vehicleModelType:
        "Designazione del modello e del tipo di veicolo in base all'immatricolazione",
      firstRegistration: "Prima registrazione (GG.MM.AAAA)",
      enginePower: "Potenza del motore (KW, ad es. 150)",
      originalEquipment: "Primo equipaggiamento",
      tireMilageHours:
        "Chilometraggio degli pneumatici (km) / ore di funzionamento",
      tireMilage: "Chilometraggio dei pneumatici (km)",
      tireHours: "Orario di funzionamento",
      milageOrHours: "Km o ore (ad es. 2000)",
      copyTire1: "Copia del pneumatico 1",
      copyTire3: "Copia del pneumatico 3",
      damageDetails: "Dettagli del danno",
      complaintReason: "Motivo del reclamo*",
      vibration: "Vibrazioni",
      notBalancable: "Non può essere bilanciato",
      sounds: "Rumori",
      airPressureLost: "Perdita di pressione dell'aria",
      worn: "Modello di abrasione",
      runningPerformance: "Chilometraggio",
      deformation: "Ammaccature / deformazioni",
      profileBreakouts: "Schede di profilo",
      cracks: "Crepe",
      drivingBehavior: "Comportamento di guida",
      pull: "Tirare",
      wetGrip: "Presa sul bagnato",
      defective:
        'Merce nuova difettosa (indicare il numero della bolla di consegna sotto "Motivo del reclamo testo")',
      otherReason:
        'Altro motivo (specificare sotto "Motivo del reclamo testo")',
      isTyreReplaced: "I pneumatici sono già stati sostituiti?",
      ifYesTyre: "Se sì, marca della ruota di scorta",
      clerkName: "Nome del responsabile*",
      conclusion: "Conclusione",
      conclusionContent:
        "<p>Queste informazioni sono complete e sono state fornite al meglio delle nostre conoscenze.<br/>Si conferma che i pneumatici in questione sono stati montati sul veicolo<br/>di cui sopra. <br /><br /><b>I pneumatici possono essere tagliati a scopo di test. </b><br /><br /><b>Se il reclamo viene accettato, ci riserviamo il diritto di rimborsare i<br/>pneumatici dopo averne accreditato il valore in proporzione, o di compensare con una consegna sostitutiva gratuita tramite<br/>.<br/></b><br /> I pneumatici accettati saranno rottamati. In caso di rifiuto, questo<br/>potrà essere recuperato. <br /><br />Si autorizza la conservazione dei dati personali di cui sopra.<br/></p>",
      agreementReadAccept: "Accordo letto e accettato*.",
      termsConditionsRead: "Leggete le Condizioni generali.",
      termsConditionsReadAccept: "Condizioni generali lette e accettate*",
      send: "Inviare",
      requiredField: "*Campo obbligatorio",
      tires: "Pneumatici",
      tirePosition: "Posizione del pneumatico",
      notKnown: "Non conosciuto",
      carSUVTractor: "AUTO/SUV/TRATTORE",
      CSTFrontLeft: "P/S/T - anteriore sinistro",
      CSTFrontRight: "P/S/T-anteriore destro",
      CSTRearLeft: "P/S/T-posteriore sinistro",
      CSTRearRight: "P/S/T-posteriore destro",
      motorcycle: "MOTO",
      motFront: "MOT-anteriore",
      motRear: "MOT-posteriore",
      truck: "Autocarro SZM",
      truckSteeringAxle1Left: "Asse sterzante per autocarro 1 sinistro",
      truckSteeringAxle1Right: "Asse sterzante per autocarro 1 destro",
      truckSteeringAxle2Left: "Asse sterzante per autocarro 2 sinistro",
      truckSteeringAxle2Right: "Asse sterzante per autocarro 2 destro",
      truckDriveAxle1LeftInner: "Asse motore del camion 1 interno sinistro",
      truckDriveAxle1LeftOuter: "Asse motore del camion 1 esterno sinistro",
      truckDriveAxle1RightInner: "Asse motore del camion 1 interno destro",
      truckDriveAxle1RightOuter: "Asse motore del camion 1 esterno destro",
      truckDriveAxle2LeftInner: "Asse motore del camion 2 esterno sinistro",
      truckDriveAxle2LeftOuter: "Asse motore del camion 2 interno sinistro",
      truckDriveAxle2RightInner: "Asse motore del camion 2 esterno destro",
      truckDriveAxle2RightOuter: "Asse motore del camion 2 interno destro",
      truckTrailingAxleLeft: "Asse di traino del camion a sinistra",
      truckTrailingAxleRight: "Asse di traino del camion a destra",
      trailerSemi: "RIMORCHIO/SEMITRAINO",
      trailerAxle1LeftOuter: "Assale del rimorchio 1 esterno sinistro",
      trailerAxle1LeftInner: "Assale del rimorchio 1 interno sinistro",
      trailerAxle1RightOuter: "Assale del rimorchio 1 esterno destro",
      trailerAxle1RightInner: "Assale del rimorchio 1 interno destro",
      trailerAxle2LeftOuter: "Assale del rimorchio 2 esterno sinistro",
      trailerAxle2LeftInner: "Assale del rimorchio 2 interno sinistro",
      trailerAxle2RightOuter: "Assale del rimorchio 2 esterno destro",
      trailerAxle2RightInner: "Assale del rimorchio 2 interno destro",
      trailerAxle3LeftOuter: "Assale del rimorchio 3 esterno sinistro",
      trailerAxle3LeftInner: "Assale del rimorchio 3 interno sinistro",
      trailerAxle3RightOuter: "Assale del rimorchio 3 esterno destro",
      trailerAxle3RightInner: "Assale del rimorchio 3 interno destro",
      DOT: "DOT (specificare TUTTE le 10-11 cifre)",
      TruckSerialNo: "Numero di serie (solo per i pneumatici per autocarri)",
      complaintReasonText: "Motivo del reclamo Testo",
      csNumberIfNeed: "Numero di cliente (se disponibile)",
    },
    teams: {
      tyre: "Commercio di pneumatici a squadre",
      car: "Concessionaria auto della squadra",
    },
    carDealers: {
      title: "Il tuo contatto personale presso Bridgestone",
    },
  },
  mainPage: {
    categories: {
      productInfo: "Informazioni sul prodotto",
      salesSupport: "Assistenza alle vendite",
    },
  },
  fireStoneProducts: {
    title: "Prodotti Firestone",
    description:
      "Scaricate qui le brochure e i volantini più recenti sui nostri pneumatici Firestone per auto, SUV e furgoni.",
    files: {
      summer: {
        title: "VANHAWK MULTISTAGIONE",
        description: "Transporter - Tutte le stagioni",
        date: "Panoramica dei prodotti 2021",
      },
      winter: {
        title: "WINTERHAWK 4",
        description: "Auto, SUV - Inverno",
        date: "Panoramica dei prodotti 2020",
      },
    },
  },
  complaintForm: {
    title: "Modulo di reclamo",
    description:
      "Compilate il seguente modulo per i reclami sui nostri pneumatici:",
    sections: {
      damageType: {
        title: "tipo di danno",
      },
      generally: {
        title: "Generale",
      },
      regulator: {
        title: "Indirizzo gommista - regolatore",
      },
    },
    fields: {
      ordinance: "Concetto di classificazione del rivenditore",
      pickupLocation: "Luogo di ritiro",
      ifAvailable: "(se disponibile)",
      companyName: "Nome (azienda)",
    },
  },
  salesPromotions: {
    title: "Promozione delle vendite",
    desc: "Con le nostre campagne di promozione delle vendite per Bridgestone e Firestone, vi sosteniamo attivamente nel dialogo con le vendite e vi forniamo ulteriori argomenti. Se anche voi volete utilizzare le promozioni per la vostra attività, potete saperne di più su questa pagina e richiedere subito di diventare un partner di vendita al dettaglio.",
    bonusCampaign: {
      title:
        '<span class="font-sm">Campagna premium Bridgestone</span><br/><h3 class="fw-bold">GUIDARE <span class="text-danger">I NOSTRI MIGLIORI</span></h3>',
      desc: "Nell'ambito della campagna DRIVE OUR BEST, i clienti che acquisteranno almeno 2 pneumatici premium Bridgestone presso i rivenditori aderenti riceveranno un buono del valore massimo di 40 CHF, spendibile presso partner interessanti come Amazon, Aral/OMV, Media Markt, REWE, Shell, Zalando e molti altri. <br/><br/>L'importo del buono dipende dal numero di pneumatici acquistati e dalla loro dimensione in pollici.",
    },
    guarantee: {
      title:
        '<span class="font-sm">Garanzia sui pneumatici Bridgestone</span><br/><h3 class="fw-bold"><span class="text-danger">PROTEZIONE</span> PNEUMATICI</h3>',
      desc: "Danni da inserimento in auto e danni da marciapiede: ciò che prima era associato a frustrazione e fastidio, Bridgestone lo risolve con successo in modo digitale, a misura di rivenditore e di cliente, con una garanzia di due anni sui pneumatici dal 2020.<br/><br/>A seconda dell'età dei pneumatici Bridgestone coperti, il vostro cliente riceverà indietro fino al 100% del prezzo di acquisto del pneumatico sostitutivo in caso di danni.<br/><br/>Novità dal 2023: I vostri clienti possono usufruire della garanzia quando acquistano 2 o più pneumatici di tutte le misure.",
    },
    premium: {
      title:
        '<span class="font-sm">Premio e garanzia Firestone</span><br/><h3 class="fw-bold"><span class="text-danger">AZIONE DI</span> VANTAGGIO</h3>',
      desc: "Partecipando alla PROMOZIONE FIRESTONE ADVANTAGE, gli acquirenti di almeno 2 pneumatici Firestone non solo ricevono una garanzia di 24 mesi sui pneumatici, che copre ad esempio i danni da marciapiede o da ingresso in auto, ma anche un buono BestChoice del valore massimo di 20 CHF.<br/><br/>Nuovo dal 2023: La partecipazione è già possibile con l'acquisto di 2 o più pneumatici per auto, SUV o furgoni di tutte le misure.",
    },
    participation: {
      title: "Richiedi ora la partecipazione",
      desc: "Volete implementare una o più delle nostre campagne nel vostro negozio? Allora potete candidarvi qui. La vostra attività sarà attivata per la/e promozione/i e riceverete il materiale promozionale per il vostro punto vendita entro 4 settimane. <br/><br/>Fate la vostra selezione:",
      success: "Grazie, la sua richiesta è stata inviata",
      bonusCampaign:
        '<span class="fw-bold">DRIVE <span class="text-danger">OUR BEST</span> - La campagna premium di Bridgestone',
      guarantee:
        '<span class="fw-bold">TYRE <span class="text-danger">PROTECT</span></span> - Garanzia sui pneumatici Bridgestone',
      advantage:
        '<span class="fw-bold">PROMOZIONE <span class="text-danger">VANTAGGIOSO</span></span> - La promozione premium di Firestone con garanzia aggiuntiva sui pneumatici.',
      premium:
        '<span class="fw-bold">PROMOZIONE <span class="text-danger">VANTAGGIOSO</span></span> - La promozione premium di Firestone con garanzia aggiuntiva sui pneumatici.',
      request: "Richiesta di partecipazione",
    },
  },
  trainings: {
    seasons: {
      all: "Tutta la stagione",
      summer: "Estate",
      winter: "Inverno",
      general: "Generale",
    },
    offer:
      "Espandiamo regolarmente la nostra offerta <br />per voi! <br /><br />Vi informeremo sui nuovi corsi di formazione <br />nella vostra casella di posta elettronica.",
    summary: {
      congratulations:
        "CONGRATULAZIONI - AVETE CONTRIBUITO CON LE VOSTRE CONOSCENZE SPECIALISTICHE A",
      participation: "Avete partecipato con successo a {Name}.",
      certificate:
        "Riceverete il vostro certificato via e-mail o potrete scaricarlo direttamente qui in formato PDF:",
      send: "Scarica il certificato",
    },
    online: {
      title: "I nostri corsi di formazione online",
      desc: "Assicuratevi le conoscenze degli esperti e, se completate con successo i rispettivi test di formazione, il vostro certificato di partecipazione personale<br> e 40 punti extra per il club dei premi.",
      content:
        "Scoprite i nostri attuali corsi di formazione online e partecipate subito qui sulla piattaforma:",
    },
    lectures: {
      title: "Corsi di formazione Bridgestone",
      desc: "Ampliate le vostre conoscenze specialistiche e prenotate i nostri corsi di formazione e le sessioni di training intensivo per voi e il vostro team. Avete la possibilità di partecipare ai corsi di formazione presso il Centro di Competenza e Formazione Bridgestone di Dietzenbach (vicino a Francoforte sul Meno) o, nel caso di corsi di formazione selezionati, di tenerli presso la vostra azienda. Potete utilizzare i vostri punti premio per i corsi di formazione e compensare tutti o parte dei costi con i vostri punti.",
      content:
        "Scoprite ora i nostri corsi di formazione attuali e richiedete una prenotazione:",
    },
    singleLecture: {
      registerForm: {
        title: "Contenuti della formazione",
        inquiry: "Richiesta",
        interested: "Sono interessato alla formazione",
        participantsNr: "Numero di partecipanti",
        pointsFromBalance: "Vorrei utilizzare i punti del mio saldo punti.",
        reduction: "Ciò corrisponde a una riduzione dei costi di {points} CHF.",
        request: "Invia una richiesta",
      },
      success: {
        thanks: "Grazie mille",
        title: "La vostra richiesta è stata inviata al team di formazione.",
        feedbackTime:
          "Riceverete un feedback entro 14 giorni per chiarire tutti i dettagli<br />.",
        points:
          "I punti premio utilizzati per l'importo di<br /> {points} punti sono stati detratti dal suo conto<br />punti.",
        refund:
          "Se il corso di formazione non si concretizza, i punti<br />naturalmente vi saranno riaccreditati.",
        queries: "Per qualsiasi domanda, si prega di contattare:",
      },
      index: {
        costs: "Costi e informazioni sulla partecipazione",
        duration: "Durata: {duration}",
        cost: "Costo {cost}: {price} CHF ({points} punti)",
        participantsNr:
          "Numero di partecipanti: min. {min} -max. {max} persone",
      },
    },
    index: {
      title: "Formazione e istruzione",
      desc: "Un vantaggio grazie alla conoscenza: assicuratevi una competenza esclusiva per voi e per il vostro team con i nostri programmi di formazione. Sia con i nostri corsi di formazione online, a cui potete partecipare direttamente sulla piattaforma, sia con i nostri corsi di formazione e seminari pratici nel centro di formazione Bridgestone, sia con i corsi di formazione esterni, i cui costi potete ridurre con i vostri punti premio.",
      online: {
        title: "Corsi di formazione online",
        desc: "Scopri la formazione online e approfondisci il mondo dei prodotti Bridgestone!",
        short_desc:
          "Scopri la formazione online e approfondisci il mondo dei prodotti Bridgestone!",
      },
      lectures: {
        title: "Corsi di formazione",
        desc: "Corsi di formazione di alta qualità presso il nostro centro di formazione o sul posto.",
      },
      external: {
        title: "Corsi di formazione esterni",
        desc: "Utilizzate i punti premio per ottenere offerte da fornitori terzi e ridurre i costi.",
      },
    },
  },
  salesSupport: {
    title: "Assistenza alle vendite",
    desc: "Vi offriamo diverse misure e campagne per sostenere attivamente le vostre vendite: dalle promozioni di vendita ad alto impulso a uno spazio di vendita attraente e all'assistenza individuale.",
    salesPromotions: {
      title: "Promozione delle vendite",
      desc: "Bonus e garanzie interessanti per i vostri clienti al momento dell'acquisto di pneumatici.",
    },
    displaysFurniture: {
      title: "Espositori e mobili",
      desc: "Utilizzate i vostri punti premio per acquistare attrezzature di alta qualità per la vostra sala vendite.",
    },
    individualSupport: {
      title: "Supporto personalizzato",
      desc: "Assicuratevi un'assistenza personalizzata con i vostri punti premio.",
    },
  },
  serviceNumber: {
    title: "Persone di contatto e numeri di assistenza",
    subtitle: "Il vostro contatto personale presso Bridgestone",
    description:
      "Siamo sempre a vostra disposizione! Trovate il vostro contatto personale Bridgestone sul sito<br/>per la vostra regione o semplicemente mettetevi in contatto con il nostro competente personale del servizio clienti.<br/>.",
    manager: "Responsabile vendite Germania",
    yourCustomerService: "Il vostro servizio clienti",
    generalCustomerService: "Servizio clienti generale",
    salesTerritory: "Area vendite",
    carDealer: "Concessionaria auto",
    centralEmail: "Contatto e-mail centrale",
    sales_manager: "Responsabile vendite Olanda",
    contact_person: "Bridgestone plus persona di contatto",
    sales_representative: "Rappresentante di vendita",
    key_account: "Responsabile dei conti chiave",
    warranty: "Garanzia",
    car_releases: "Omologazioni auto",
    motorcycle_releases: "Omologazioni per moto",
    commercial_vt: "Pneumatici per veicoli commerciali",
    agricultural_tires: "Pneumatici agricoli",
  },
  directions: {
    west: "Ovest",
    north: "Nord",
    east: "Est",
    south: "Sud",
  },
  training: {
    title: "Certificato e {points} punti extra per lei!",
    subtitle:
      "Ricevete il vostro certificato di partecipazione personale e {points} punti extra per il club dei premi.",
    description:
      "E come? È semplice: completate il test di formazione dopo il video! Il test apparirà non appena avrete guardato il video per intero!",
  },
  about: {
    title: "Informazioni su Bridgestone <span class='text-danger'>Plus</span>",
    description:
      "IL TUO <span class='text-danger'>PLUS</span> CON BRIDGESTONE - questo è il motivo conduttore dell'intero programma BRIDGESTONE <span class='text-danger'>PLUS</span><br/>per i nostri partner commerciali. Scoprite i numerosi vantaggi esclusivi.",
    sections: {
      first: {
        title: "Prodotti premiati nel segmento premium e di qualità",
      },
      second: {
        title: "Programma di bonus interessante",
      },
      third: {
        title: "Supporto alle vendite efficace",
        description:
          "Maggiori opportunità per esperienze di shopping esclusive e per la vostra presenza digitale in punti di contatto rilevanti.",
        subtitle: "Le nostre promozioni di vendita collaudate",
        pointInfo:
          "Approfitate di ulteriori argomenti di vendita e i vostri clienti di interessanti premi e campagne a valore aggiunto.",
        numberInfo:
          "Elaborazione digitale diretta con il vostro cliente - nessun lavoro aggiuntivo per voi!",
        subtitle2: "Un aspetto forte con le nostre attrezzature di vendita",
        description2:
          "Create un ambiente attraente per la vostra sala vendite e offrite ai vostri clienti un soggiorno piacevole con i nostri moduli per aree di vendita, aree espositive, aree di attesa e aree esterne e soluzioni digitali!",
        description3:
          "Raccogliete punti e <b>promuovete la vostra azienda</b> con noi",
      },
      fourth: {
        title: "TUTTO SU UN'UNICA PIATTAFORMA: IL PORTALE BRIDGESTONE PLUS",
        description:
          "Con l'accesso personale al portale online, avrete accesso diretto all'ampia gamma di prodotti BRIDGESTONE <span class='text-danger'>PLUS</span> di<br>.",
        list: {
          program: "Programma a punti",
          shop: "Negozio a premi",
          priceList: "Listini prezzi",
          productInfo: "Informazioni sui prodotti",
          salePromotion: "Assistenza alle vendite",
          onlineTrainings: "Corsi di formazione online",
          andMore: "e molto altro ancora.",
        },
        title2: "Sessioni di formazione online regolari",
        description2:
          "Rimanere aggiornati e approfittare della formazione online Bridgestone insieme al proprio team",
      },
      points: {
        title:
          "Corsi di formazione online in corso nei settori dei prodotti e delle vendite:",
        list: {
          one: "Formazione alle vendite",
          two: "Costruzioni di pneumatici",
          three: "Riconoscere i modelli di danno",
        },
        subtitle: "LA VOSTRA PARTECIPAZIONE SARÀ PREMIATA",
        description:
          "Riceverete <b>40 punti</b> e un <b>certificato di partecipazione</b> per ogni corso di formazione online completato!",
      },
    },
    fullPremium:
      "L'intera gamma premium Bridgestone per autovetture per il mercato del ricambio è stata <strong>costantemente classificata come \"A\" per l'aderenza sul bagnato</strong>.",
  },
  her: "Il vostro",
  seasons: {
    summer: "Estate",
    winter: "Inverno",
    all: "Tutte le stagioni",
  },
  loginPage: {
    title: "Accedi",
    resetTitle:
      'Benvenuti da BRIDGESTONE <span class="text-danger">PLUS</span>',
    desc1:
      'Siete già registrati con successo sul portale BRIDGESTONE <span class="text-danger">PLUS</span>.',
    desc2: "Accedere quindi con l'indirizzo e-mail e la password.",
    desc3: "Accedere con l'indirizzo e-mail e la password.",
    resetSubTitle:
      'Siete un partecipante al Bridgestone <span class="text-danger">TYRECLUB</span>?',
    resetDesc:
      "Quindi impostare una nuova password per l'indirizzo e-mail utilizzato per il <span class='text-danger'>TYRECLUB</span> utilizzando la funzione <b>Password dimenticata</b>.",
    footer: "L'accesso verrà effettuato automaticamente.",
    resetNewPass: "IMPOSTARE UNA NUOVA PASSWORD",
    noAccount: "Non ho ancora un account",
    error: "Dati di accesso errati, riprovare!",
    logWithAzure: "Accedere con Azure",
  },
  maintenance: {
    title: "Lavori di manutenzione!",
    desc: 'Sono in corso i necessari lavori di manutenzione dei server.<br/><br/>Pertanto, l\'accesso a <b>BRIDGESTONE <span class="text-danger">PLUS</span></b> non è attualmente disponibile.<br/><br/>Vi chiediamo di avere pazienza e vi ringraziamo per la vostra comprensione.<br/><br/> Il vostro team Bridgestone',
  },
  contactPage: {
    title: "Modulo di reclamo",
    description:
      "Compilate il seguente modulo per i reclami sui nostri pneumatici:",
    damage: "Danno materiale",
    personalInjury: "Lesioni personali",
  },
  yesText: "Sì",
  noText: "no",
  wrongFileError: "Il formato di file richiesto è PDF",
  toastMessages: {
    addProduct: "Il prodotto è stato aggiunto al carrello.",
    addProducts: "I vostri prodotti sono stati aggiunti al carrello.",
    profileSaved: "I dati del profilo sono stati salvati",
    canAddProduct: "Non hai abbastanza punti.",
    customerNumberSaved: "Numero cliente salvato",
    customerNumberExist: "Numero cliente disponibile",
    complaintForm: "La sua richiesta è stata accettata. Attendere una risposta",
    openHourSaved: "Gli orari di apertura sono stati salvati",
    changeParentId:
      "Non è possibile modificare la filiale con il numero cliente principale se ha filiali subordinate.",
    requestSent: "La richiesta è stata inviata",
    completeProfileRequired:
      "Per procedere all'acquisto nel negozio è necessario compilare il proprio profilo al 100%.",
    accessDenied: "Accesso negato",
    incomplete_address: "L'indirizzo è incompleto. si prega di controllare",
    waitMoment: "Aspetta un attimo",
    favoriteAdded: "Aggiunto ai preferiti.",
    favoriteRemoved: "Rimosso dai preferiti.",
    downloadFinished: "Download terminato",
    selectOneField: "Seleziona un campo",
    noVoucher: "Il buono non è stato trovato",
  },
  order: {
    number: "Numero d'ordine",
    createdDate: "Ordinato il",
    description:
      "Qui troverete una panoramica degli ordini del vostro negozio premi.",
    success:
      "Grazie mille! Il suo ordine è andato a buon fine. Tra pochi minuti riceverete una conferma d'ordine nella vostra casella di posta elettronica.",
    anyOrder: "Nessun comando",
    shippedAt: "Spedito a",
    sku: "SKU",
    status: {
      created: "Creato",
      confirm_order: "Confermare l'ordine",
      ready_for_shipment: "Pronto per la spedizione",
      rejected: "Rifiutato",
      processed: "Elaborato",
      shipped: "Spedito",
      returned: "È tornato",
      finished: "Finito",
    },
    details: {
      title: "Dettagli dell'ordine",
      description: "Revisione e gestione dei nuovi ordini",
    },
    date: "Data dell'ordine",
    products: "Prodotti",
    quantity_short: "pz",
  },
  orders: "Ordini",
  hunter: {
    title: "Hunter",
    description:
      "Macchine e attrezzature di alta qualità per la vostra officina sono un investimento per il successo della vostra attività. Utilizzate i vostri punti premio BRIDGESTONE <span class='text-danger'>PLUS</span> per ridurre il prezzo di acquisto delle macchine da officina HUNTER. I punti premio utilizzati saranno saldati direttamente con HUNTER e avranno quindi un effetto sul prezzo di acquisto.",
    priceInfo:
      "Prezzo netto comprensivo di trasporto e messa in servizio/istruzione",
    pointsInfo: "Prezzo netto in punti",
    investInfo:
      "I punti possono essere detratti o accreditati tramite il supporto agli investimenti.",
    contactInfo:
      "Se avete domande sulla procedura, contattateci personalmente. Contatto",
    specification: "Specifiche",
    pointDiscount: "Questo corrisponde a {price} CHF",
    form: {
      title: "Sono interessato a",
      subtitle: "Desidero utilizzare i punti del mio saldo punti",
      description:
        "Vi contatteremo dopo la conferma della vostra richiesta. Naturalmente, siamo a disposizione per rispondere alle vostre domande in qualsiasi momento.",
    },
  },
  intro: {
    step1: {
      title: "PERSONALIZZATO",
      description:
        "Qui troverete informazioni sul vostro account Plus e sulla vostra casella postale Plus.",
    },
    step2: {
      title: "PANORAMICA DEI PUNTI",
      description:
        "Qui troverete la panoramica dei vostri punti. È possibile visualizzare le proprie prestazioni negli ultimi dodici mesi e guadagnare premi con i punti.",
    },
    step3: {
      title: "RIMANETE AGGIORNATI",
      description:
        "Vi spieghiamo le funzioni di Bridgestone Plus e scopriamo cos'altro è possibile fare.",
    },
  },
  wholesaler: {
    dashboard: {
      title: "{name} Cruscotto",
      extraTitle: "WHOLESALER DASHBOARD",
      description:
        "Benvenuti nel vostro cruscotto. Qui potete visualizzare le cifre chiave attuali e le aziende partecipanti della vostra base clienti.",
      overview: {
        title: "Panoramica dei clienti partecipanti",
        description:
          "Aziende che si sono registrate presso BRIDGESTONE PLUS e che possiamo assegnare alla vostra azienda tramite il codice cliente.",
        month: "Novità del mese",
        year: "Novità di quest'anno",
        all: "Totale",
      },
      credits: {
        title: "Punti crediti {name}",
        description:
          "Punti premio assegnati alle aziende partecipanti in base ai dati di vendita caricati. Questa visualizzazione mostra i punti regolari senza promozioni speciali.",
        month: "Il mese scorso",
        year: "Anno in corso",
        prev_year: "Totale",
        prev_month: "le mois précédent",
        allDealers: "Tutti i punti di vendita",
      },
      details: {
        title: "I clienti partecipanti in dettaglio",
        description:
          'Di seguito sono elencate le aziende che si sono registrate con un numero cliente {name} su BRIDGESTONE <span class="text-danger">PLUS</span> e che sono assegnate a voi come persona responsabile. È sufficiente utilizzare le funzioni di ordinamento per una diversa sequenza di pneumatici o la maschera di ricerca.',
      },
      lastImport:
        'Ultima importazione di dati di vendita: <br/> <span class="text-danger">{date}</span>',
      loadMore: "Carica altri 20 rivenditori",
      tyres: {
        title: "Pneumatici",
        description: "Pneumatici acquistati dai partecipanti al programma",
      },
      reload: "Ricaricare",
    },
  },
  staff: {
    dashboard: {
      title: "Cruscotto del servizio esterno",
      description:
        "Benvenuti nel vostro cruscotto. Qui potete visualizzare le cifre chiave attuali e le aziende partecipanti della vostra base clienti.",
      overview: {
        title: "Panoramica dei clienti partecipanti",
        description:
          'Aziende che si sono registrate presso BRIDGESTONE <span class="text-danger">PLUS</span> e che possiamo assegnarvi tramite il codice cliente.',
        month: "Novità del mese",
        year: "Novità di quest'anno",
        all: "Totale",
      },
      credits: {
        title: "Punti crediti",
        description:
          "Punti premio assegnati alle aziende partecipanti in base ai dati di vendita presentati.",
        month: "Il mese scorso",
        year: "Anno in corso",
        prev_year: "Totale",
        prev_month: "Mese precedente",
        allDealers: "Tutti i punti di vendita",
        allPoints: "Tutti i punti",
      },
      details: {
        title: "I clienti partecipanti in dettaglio",
        description:
          'Di seguito sono elencate le aziende che si sono registrate con un numero cliente Bridgestone su BRIDGESTONE <span class="text-danger">PLUS</span> e che sono assegnate a voi come persona responsabile. È sufficiente utilizzare le funzioni di ordinamento per una diversa sequenza di pneumatici o la maschera di ricerca.<br/><br/> <b>Nota:</b> se si clicca sul punteggio, si accede all\'estratto conto dettagliato.',
      },
      lastImport:
        "Ultima importazione di dati di vendita: <br/> <span class='text-danger'>{date}</span>",
      kickback: {
        description:
          "Alle aziende partecipanti vengono accreditati i compensi kickback in base ai dati di vendita presentati.",
      },
      tyres: {
        title: "Pneumatici",
        description: "Pneumatici acquistati dai partecipanti al programma",
      },
      reload: "Ricaricare",
      exports: {
        title: "Excels Esportati",
        head: {
          name: "Nome",
          status: "Stato",
        },
      },
    },
  },
  newsFeed: {
    more: "Maggiori informazioni su",
  },
  investment: {
    title: "Sostegno agli investimenti",
    description:
      "Bridgestone vi supporta anche individualmente con i vostri investimenti operativi. Che si tratti dell'acquisto di macchine o attrezzature per l'officina, di veicoli sostitutivi per l'officina o di attività di marketing come pubblicità o posizionamento di banner online, ecc, potete utilizzare i vostri punti premio BRIDGESTONE PLUS per rifinanziare i vostri investimenti. - Utilizzate i vostri punti premio BRIDGESTONE PLUS per rifinanziare i vostri investimenti. Una volta effettuato l'investimento, è sufficiente inviare qui la fattura del relativo fornitore e indicare quanti punti premio si desidera utilizzare. Seguite le istruzioni riportate di seguito.",
    description_old:
      "Sostegno agli investimenti per le attrezzature dell'officina sovvenzione alla pubblicità per i progetti di marketing",
    info: {
      paragraph2_old:
        "Aggiornate l'attrezzatura della vostra officina o il vostro locale di vendita o fate pubblicità per migliorare la commercializzazione dei vostri prodotti.Comunicateci il valore dei punti che desiderate spendere per questo premio. La spesa minima in punti è di 1.250 punti.Valore per punto = 0,25 CHF",
      paragraph2:
        "Realizzate l'investimento desiderato e saldate la fattura del fornitore terzo.",
      paragraph3_old:
        "Per liquidare il premio, abbiamo bisogno della vostra fattura per l'importo dei punti richiesti (numero di punti x 0,25 CHF = importo netto della fattura) e di una copia della fattura originale. È possibile trovare un esempio di fattura",
      paragraph3:
        "Infine, è possibile richiedere una sovvenzione qui su questa pagina, nel campo di richiesta a destra.",
      paragraph4_old:
        "Contattateci personalmente per avviare le fasi successive.",
    },
    excludeText:
      "Si precisa che sono esclusi gli investimenti in offerte di concorrenti diretti.",
    here: "qui",
    contactPerson: "Persona di contatto",
    email: "e-mail",
    phone: "Tel",
    payInfo: "Il pagamento può richiedere fino a 8 settimane!",
  },
  notice: "Nota",
  noticeDescription:
    "In caso di danni a cose e/o persone, si prega di contattare direttamente Bridgestone CHF NV/SA Filiale Germania Tel.: 0049-6172-408-435, E-Mail: <a href='mailto:{email}'>{email}</a>, in quanto sono soggetti a trattamento separato.",
  yourEmail: "Il vostro indirizzo e-mail",
  addressEndCustomer: "Indirizzo del cliente finale",
  tireSizeExample: "Dimensioni del pneumatico (ad es. 215/60/16)",
  profileDesignation:
    "Designazione del profilo, comprese le specifiche (ad esempio: RE050A, R168 Eco, ...)",
  speedLoadIndex: "Indice di velocità/carico",
  restDay: "Giorno di riposo",
  breakTimes: "Tempi di pausa",
  claimFrom: {
    pdf: {
      number: "N° del modulo",
      tireSizeExample: "Dimensioni del pneumatico",
      dot: "DOT",
      vehicleModelType: "Modello/tipo di veicolo",
      enginePower: "Potenza del motore (KW)",
      speedLoadIndex: "Indice di velocità",
      profile: "Profilo",
      damage: "Danni",
      replacementStamp: "Marchio di ricambio",
      personalInjury: "Lesioni personali",
      tiresReplaced: "Pneumatici sostituiti",
      agb: "CONDIZIONI GENERALI DI VENDITA",
      clerkName: "Nome del responsabile",
      complaintReason: "Motivo del reclamo",
      complaintReasonText: "Motivo del reclamo Testo",
      vehicleTyres: "Veicolo/pneumatici",
    },
  },
  fuelCalculator: {
    oldLabel: "VECCHIA ETICHETTA DEL CARBURANTE",
    selectOldLabel: "Selezionare il valore dell'etichetta",
    tyreLife: "Chilometraggio totale (del set di pneumatici IN KM)",
    tyreLifeLabel: "Inserire il chilometraggio totale, ad es. 40.000",
    fuelPrice: "Prezzo del carburante (al litro IN CHF)",
    fuelPriceLabel: "Inserire il prezzo della benzina, ad esempio 1,82.",
    newLabel: "ETICHETTA DEL NUOVO CARBURANTE",
    selectNewLabel: "Selezionare il valore dell'etichetta",
    fuelConsumption: "Consumo di carburante (del veicolo per 100 km in litri)",
    fuelConsumptionLabel: "Inserire il consumo di carburante, ad es. 7,8",
    table: {
      euroSave: "Risparmio per l'intera durata",
      fuelSavePercent: "cambiamento del consumo di carburante",
      newConsumption: "Nuovo consumo di carburante per 100 km",
      fuelSaveLiter: "Il consumo di carburante a 100 km diminuisce di",
      fuelSaveTotalLiter:
        "Il consumo di carburante si riduce per l'intera durata di vita di",
    },
    results: "Risultati e potenziali risparmi",
    please: "Si prega di notare le informazioni sotto i risultati",
    calcHeader: "Inserite qui i dati chiave dei pneumatici e del veicolo:",
    mainDesc:
      "Con il <b>calcolatore di risparmio di carburante</b> è possibile calcolare in modo semplice e diretto il risparmio che una classe di resistenza al rotolamento migliore può ottenere con i pneumatici nuovi rispetto a una classe peggiore. È sufficiente inserire i valori nel modulo.<br/><br/><b>Il risultato si riferisce al chilometraggio totale e offre un ulteriore argomento di forza nella vendita: raccomandare i pneumatici premium Bridgestone con resistenza al rotolamento ottimizzata!",
    description:
      "I pneumatici con bassa resistenza al rotolamento e gonfiati correttamente (secondo le specifiche del produttore) possono far risparmiare fino al 10% di carburante. Ciò si traduce in un risparmio economico sui costi di esercizio o, nel caso dei veicoli elettrici ad esempio, consente al conducente di viaggiare più a lungo prima di fare rifornimento o di ricaricare. La classe di resistenza al rotolamento va da A (più efficiente) a E (meno efficiente). Più alta è la classe energetica, minore è la resistenza al rotolamento.",
    noticeText:
      "Sulla base dei dati della Commissione Europea, si è ipotizzato un risparmio massimo di carburante del 10% in tutte le classi di etichettatura (etichetta A rispetto all'etichetta E). Si tratta di un valore massimo, che presuppone in particolare che i pneumatici vengano utilizzati alle pressioni d'aria ottimali indicate dal costruttore del veicolo o del pneumatico (maggiori informazioni in merito sono disponibili sul sito web della Commissione Europea: <a href='https://commission.Europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en'>https://commission.Europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en)</a>. Sulla base del risparmio massimo di carburante, ipotizzando una riduzione lineare, si ottiene una differenza di circa il 2,5% per ogni passaggio alla classe di etichettatura successiva migliore. Questa percentuale viene dedotta di conseguenza dal valore iniziale del consumo di benzina specificato dalla logica di calcolo. Esempio: è stato specificato un valore di consumo di carburante di 7,0 litri per 100 km. Si deve calcolare il risparmio di carburante per il passaggio dall'etichetta C all'etichetta A. In base alla logica di cui sopra, si ottiene un risparmio del 2,5% * 2 = 5%. Includendo il valore di consumo dichiarato, si ottiene il seguente nuovo valore di consumo: 7,0 l * (100 % - 5 %) = 6,65 l e quindi un risparmio di 0,35 l / 100 km.<br/><br/>Bridgestone sottolinea espressamente che la percentuale di variazione applicata sopra è un valore teorico che riflette la gamma superiore di possibili risparmi di carburante dovuti alla resistenza al rotolamento del pneumatico. Si tratta quindi solo di un'approssimazione e non sarà sempre realizzabile nella pratica, poiché il consumo di carburante di un veicolo (e di conseguenza il suo risparmio) dipende da molti altri fattori oltre alla resistenza al rotolamento del pneumatico (ad esempio stile di guida, velocità, pressione dell'aria, pressione del pneumatico): Stile di guida, velocità, pressione del pneumatico, temperatura del pneumatico e dell'ambiente, resistenza dell'aria del veicolo, carico del veicolo, condizioni della strada e impostazioni del telaio e del veicolo), che si influenzano a vicenda. I risultati dei calcoli effettuati sono quindi solo una stima approssimativa e non vincolante, per la cui accuratezza e precisione Bridgestone non si assume alcuna responsabilità.",
  },
  legalNotice: "Informazioni legali",
  addCsNumber: {
    body: "È sicuro di voler salvare questo numero di cliente? L'azione blocca l'elaborazione dei dati finché l'amministratore non la autorizza.",
  },
  priceDescription:
    "Scaricate i listini prezzi attuali per il vostro utilizzo.",
  pricatDescription:
    "Qui potete ottenere i file Pricat per il vostro sistema di gestione delle merci.",
  pricat: {
    title: "Prezzo",
    description:
      "Scaricate qui i record di dati CSV e TESTO per la gestione della merce, i sistemi IT ecc.",
  },
  fillProfile: "Compilare il profilo per scaricare il certificato,",
  certificate: {
    header: "CERTIFICATO",
    atCourse: "hanno partecipato con successo al corso",
    takePart: "partecipato.",
    contains: "COMPONENTI DEL CORSO",
  },
  afterTraining: {
    congratulations: "Congratulazioni",
    allAnswer: "Hai risposto correttamente a tutte le domande",
    points: "Riceverete {points} immediatamente sul vostro conto!",
    clickToProfile: "clicca sul link",
  },
  kickback: {
    title: "Tassa di kickback",
    word: "Kick-back",
    description:
      "Alle aziende partecipanti vengono accreditati i compensi kickback in base ai dati di vendita presentati.",
  },
  externalLinks: {
    tyreBuy: "Ordinare i pneumatici",
  },
  loginPageSteps: {
    welcome:
      "Benvenuti su BRIDGESTONE PLUS, il portale a valore aggiunto di Bridgestone.",
    step1: {
      title: "nuovo qui?",
      description:
        "È la prima volta che visita il portale BRIDGESTONE <span class='text-danger'>PLUS</span>?<br /><br />Allora si registri subito!",
      actionBtn: "REGISTRARSI ORA",
    },
    step2: {
      title: "Rivenditore <span class='text-danger'>TYRECLUB</span>",
      description:
        "Siete già in possesso dei dati di accesso del precedente <span class='text-danger'>TYRECLUB</span> Bridgestone?<br /><br />Allora impostate qui la vostra nuova password con l'indirizzo e-mail utilizzato per il <span class='text-danger'>TYRECLUB</span>.",
      actionBtn: "IMPOSTARE UNA NUOVA PASSWORD",
    },
    step3: {
      title: "Benvenuti a BRIDGESTONE <span class='text-danger'>PLUS</span>",
      description:
        "Accedere con l'indirizzo e-mail e la password.<br/><br/><b>Sei nuovo qui?</b><br/><br/>Creare quindi un nuovo account utente utilizzando la funzione REGISTRAZIONE.<br/><br/>Verrà quindi effettuato automaticamente l'accesso.",
      actionBtn: "REGISTRAZIONE",
    },
    info: 'Hai bisogno di aiuto? Ci contatti per favore: <a href="mailto:{email}">{email}</a>',
  },
  marketingModal: {
    title: "Termini e condizioni generali e condizioni di partecipazione",
    description:
      "Per l'accettazione della \"lettera d'impegno\" è necessario inviare una copia via e-mail.",
    content:
      'Termini e condizioni generali di Bridgestone CHFope NV/SA, Filiale dei Paesi Bassi, con sede legale in Nieuwe Weideweg1 NL- 6121 PD Born Netherlands - K.v.K. 66469767 (di seguito denominata "Bridgestone").',
    point1Title: "Partecipazione",
    point1Desc:
      "I termini e le condizioni generali non implicano alcun impegno da parte del Partecipante a raggiungere una quota di mercato stabilita da Bridgestone, né obbligano il Partecipante a vendere esclusivamente pneumatici Bridgestone. <br/>Resta inteso che il Partecipante rimane libero di determinare i propri prezzi di rivendita dei pneumatici senza alcuna restrizione, anche in presenza di eventuali raccomandazioni, che devono comunque essere intese come non vincolanti. <br/>I requisiti per la partecipazione a BS PLUS sono vincolanti per l'azienda partecipante con cui è stato stipulato l'accordo (di seguito denominata \"Partecipante\"). Il Partecipante riconosce che l'ammissione alla partecipazione a BS PLUS è a discrezione di Bridgestone e che non è valida alcuna richiesta di ammissione nei confronti di Bridgestone. Il trasferimento o la cessione dei conti dei Partecipanti è espressamente vietato, salvo diversa indicazione di Bridgestone. Non è consentita la costituzione in pegno dell'account del Partecipante. <br/>I partecipanti sono tenuti ad aggiornare tempestivamente i propri dati personali online. La mancata osservanza di questo obbligo può comportare costi aggiuntivi, ritardi, aumento del rischio di danneggiamento o perdita dei premi e altri danni associati.",
    point2Title: "Commissioni di kickback e accredito di punti marketing",
    point2Desc:
      "Il livello di ingresso per il pay-out prevede che il Partecipante acquisti un volume minimo di sessanta (60) pneumatici Bridgestone per autovetture, autocarri leggeri, 4x4 estivi, invernali e per tutte le stagioni presso i distributori selezionati dal 1° aprile 2024 al 31 dicembre 2024. Se il volume minimo annuale non viene raggiunto, al Partecipante non verrà accreditata alcuna commissione di kickback. A partire dal 2025, il livello di ingresso per il pagamento sarà di centoventi (120) pneumatici Bridgestone per auto, autocarri leggeri, 4x4 estivi, invernali e per tutte le stagioni presso i distributori selezionati dal 1° gennaio al 31 dicembre. <br/>Periodi rilevanti e contabili per il calcolo dei punti a partire dal 2025: gennaio-dicembre di ogni anno. <br/>Le spese di restituzione e i punti marketing non si applicano ai prodotti 2A, ai pneumatici dimostrativi, agli EAN del listino non attivi... I punti non utilizzati dell'anno precedente scadono a marzo dell'anno successivo. Ad esempio, i punti non utilizzati del 2024 scadono il 01 marzo 2025. <br/>I punti saranno accreditati al Partecipante esclusivamente su iniziativa di Bridgestone e in stretta conformità con le condizioni stabilite nella scheda Condizioni della piattaforma Bridgestone plus. Il numero di punti concessi per tipo di pneumatici è accessibile nella piattaforma BS. https://plus.bridgestone.nl",
    point3Title: "Premi",
    point31Title: "Punti di marketing",
    point31Desc:
      "Il Partecipante ha nominato un dipendente o un agente vicario per recuperare i premi a suo nome. Questa persona ha accesso al conto punti del Partecipante. <br/>I Partecipanti hanno la possibilità di riscattare i punti accreditati per i premi offerti in natura e/o servizi. Il pagamento dell'equivalente valore in denaro dei punti accumulati non è consentito, a meno che non sia espressamente indicato nel sistema di premi. Sul conto del Partecipante non maturano interessi. I punti possono essere riscattati se il conto punti presenta il saldo necessario per il premio specifico. I partecipanti non hanno diritto a nessun premio in particolare e il riscatto è soggetto a disponibilità fino a esaurimento scorte. <br/>Il Partecipante ha la possibilità di riscattare i punti accreditati per i premi offerti in natura e/o servizi. Il pagamento dell'equivalente valore in denaro dei punti raccolti non è consentito, a meno che non sia espressamente indicato nel sistema di premi. Non saranno corrisposti interessi sul conto del Partecipante. I punti raccolti possono essere riscattati se il conto punti presenta il saldo necessario per il premio specifico. I partecipanti non hanno diritto a nessun premio in particolare e il riscatto è soggetto a disponibilità fino a esaurimento scorte. <br/>Bridgestone si riserva il diritto di correggere eventuali errori di etichettatura dei premi. I punti riscattati non sono trasferibili e non possono essere scambiati con altri punti o premi diversi. Una volta effettuato l'ordine, il Partecipante riceverà tempestivamente una conferma di ricezione.  Bridgestone verificherà tempestivamente tutti i dati pertinenti e valuterà la disponibilità del premio. Se non diversamente specificato, tutte le prestazioni e le dimensioni dei premi rimangono quelle descritte. <br/>I punti riscattati non possono essere scambiati con punti o premi. Una volta effettuato l'ordine, il partecipante riceverà tempestivamente una conferma di ricezione. Bridgestone verificherà tempestivamente tutti i dati rilevanti e la disponibilità del premio. Se non esplicitamente indicato diversamente, tutte le specifiche di prestazioni, dimensioni, peso e dimensioni sono valori approssimativi e vengono forniti solo a scopo descrittivo; non costituiscono proprietà garantite. I tempi di consegna saranno comunicati separatamente al Partecipante dopo l'effettuazione dell'ordine. Nel caso in cui l'articolo ordinato non sia disponibile o non possa essere consegnato, Bridgestone si riserva il diritto di inviare al Partecipante un articolo simile o di annullare l'ordine. <br/>I punti marketing devono essere utilizzati dal Partecipante entro il 31 marzo dell'anno successivo, pena la loro perdita.",
    point32Title: "Tassa di compensazione",
    point32Desc:
      "Il Partecipante riceverà una commissione di contraccolpo al raggiungimento degli impegni presi, direttamente da Bridgestone o da un fornitore di servizi selezionato. <br/>La commissione di contraccolpo matura quando le Condizioni di partecipazione sono accettate dal Partecipante attraverso gli ordini di pneumatici effettuati dai distributori nominati da Bridgestone. Bridgestone o un fornitore di servizi selezionato eroga le commissioni di kickback al Partecipante una volta all'anno, dopo aver verificato l'accuratezza dei dati raccolti e a condizione che vengano rispettati gli impegni di cui sopra. L'esborso avviene entro il primo trimestre dell'anno successivo. Ad esempio: la commissione di kickback per l'anno 2024 viene erogata nel primo trimestre del 2025. <br/>Questo processo viene eseguito automaticamente dopo una revisione completa degli ordini di pneumatici del Partecipante e dei dati associati. Il Partecipante riceve le commissioni di tangente direttamente da Bridgestone o da un fornitore di servizi selezionato. Contemporaneamente, il Partecipante riceverà un documento da inserire nei propri registri finanziari.",
    point4Title: "PUNTEGGIO / PASSWORD",
    point4Desc:
      "I punti sono registrati con il numero del partecipante. Eventuali obiezioni all'esattezza o alla completezza del punteggio devono essere presentate per iscritto entro un mese dal momento in cui se ne viene a conoscenza. La mancata presentazione di un'obiezione in tempo utile sarà considerata come un'approvazione del punteggio. Anche dopo la scadenza del termine, è possibile richiedere una correzione del punteggio riportato se il Partecipante può dimostrare in modo inequivocabile l'inesattezza e/o l'incompletezza. Il Partecipante è tenuto a garantire la riservatezza della propria password e, in caso di sospetto che un'altra persona sia venuta a conoscenza della password o di qualsiasi altro uso improprio, è tenuto a modificare tempestivamente la propria password o ad informare tempestivamente Bridgestone.",
    point5Title: "DIFETTI/DIFETTI",
    point5Desc:
      "I difetti degli articoli consegnati devono essere segnalati immediatamente per iscritto. In caso contrario, si applicano le disposizioni di legge.",
    point6Title: "CESSAZIONE",
    point6Desc:
      "La partecipazione a BS PLUS è volontaria e i partecipanti possono scegliere di interrompere la loro partecipazione in qualsiasi momento, comunicandolo a Bridgestone. È importante notare che la cessazione della partecipazione non influisce sul riscatto dei punti accumulati. Bridgestone si riserva il diritto di escludere un partecipante dal programma per motivi giustificati.",
    point7Title: "RESPONSABILITÀ",
    point7Desc:
      "Il Partecipante assume a proprio rischio e pericolo tutti gli obblighi connessi alla propria organizzazione aziendale relativi, a titolo esemplificativo, ai rapporti di lavoro subordinato e autonomo, ivi compresi gli obblighi assicurativi, la corretta gestione fiscale e amministrativa dell'azienda e l'osservanza delle norme vigenti in materia di ambiente, sicurezza e prevenzione degli infortuni. <br/>Salvo il caso di dolo o colpa grave, Bridgestone non sarà responsabile di eventuali danni causati dal Partecipante nello svolgimento delle attività di cui alle Condizioni.",
    point8Title: "MODIFICA DELLE CONDIZIONI DI PARTECIPAZIONE E ORDINAZIONE",
    point8Desc:
      "Bridgestone si riserva il diritto di interrompere il sistema di premi con un periodo di preavviso di 3 mesi, in caso di motivi importanti anche senza rispettare tale periodo di preavviso, salvaguardando ragionevolmente gli interessi del Partecipante. Bridgestone si riserva inoltre il diritto di modificare o integrare i termini e le condizioni nella misura in cui ciò sia necessario ai fini di un'elaborazione più semplice e sicura e, in particolare, per prevenire gli abusi.Il Partecipante sarà informato in anticipo di qualsiasi modifica. Una modifica e/o un'integrazione si considera approvata se non viene disdetta entro un mese dalla sua conoscenza o se il Partecipante partecipa nuovamente al programma di premi dopo la scadenza di tale termine.",
    point9Title: "RISERVATEZZA",
    point9Desc:
      "Il Partecipante si impegna, per sé e per i propri dipendenti e collaboratori, a non divulgare a terzi e a non utilizzare informazioni di natura riservata, quali informazioni tecniche, dati pubblicitari o finanziari, informazioni commerciali, know-how, prezzi, costi, informazioni amministrative, progetti operativi presenti e futuri, strategie di Bridgestone, o qualsiasi altra informazione che al momento della divulgazione non sia ancora di dominio pubblico. Questa clausola deve essere intesa come vincolante anche per i successivi cinque anni dalla cessazione della partecipazione.",
    point10Title: "PROTEZIONE DEI DATI",
    point10Desc:
      "Bridgestone, il fornitore di servizi selezionato e il Partecipante si impegnano a rispettare tutti gli obblighi previsti dal Regolamento (UE) 2016/679 del Parlamento CHFopeo e del Consiglio del 27 aprile 2016 relativo alla \"protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonché alla libera circolazione di tali dati\" (di seguito \"GDPR\") a, nonché le relative normative nazionali e i provvedimenti dell'Autorità Garante per la protezione dei dati personali. Per partecipare al BS PLUS è necessario raccogliere, conservare e utilizzare diversi dati personali. Questi dati sono necessari per aprire un conto punti personale per il Partecipante e per poter inviare informazioni relative al programma di premi. I dati obbligatori richiesti per la partecipazione comprendono la ragione sociale, il cognome, il nome, la posizione in azienda, l'indirizzo postale completo, il numero di telefono, il numero di BTW, il numero di conto bancario e l'indirizzo e-mail. Ai fini dell'elaborazione e dell'implementazione del BS PLUS, i dati del Partecipante saranno memorizzati e utilizzati da TAKTZEIT, Bridgestone o da una società di servizi incaricata da TAKTZEIT. Bridgestone e TAKTZEIT si impegnano inoltre a rispettare le norme di legge sulla protezione dei dati. I dati saranno trasmessi a terzi solo se questi ultimi fungono da agenti ausiliari, ad esempio per l'elaborazione di un ordine di premi. Con la partecipazione al programma di premi, il partecipante dichiara il proprio consenso confermandolo, che può essere revocato per iscritto in qualsiasi momento. Con la dichiarazione di consenso, il Partecipante riceve la newsletter corrispondente. È possibile annullare l'iscrizione alla newsletter in qualsiasi momento tramite la voce di menu \"Contatti &gt; Annullamento dell'iscrizione alla newsletter\".",
    point11Title: "Proprietà intellettuale",
    point11Desc:
      "Il Partecipante riconosce e accetta che tutti i diritti di proprietà intellettuale (di seguito denominati \"DPI\"), presenti e futuri, relativi a, esistenti o in qualche modo connessi al BS Plus sono di proprietà del gruppo Bridgestone. Il Partecipante è autorizzato a utilizzare i DPI esclusivamente in relazione alla sua attività di vendita di pneumatici e di fornitura di servizi. I progetti di riconoscimento interno ed esterno del punto vendita devono essere approvati da Bridgestone. Resta inteso che se il Partecipante intende utilizzare i DPI in qualsiasi forma di comunicazione al pubblico, il materiale promozionale e pubblicitario preparato a tale scopo deve essere sottoposto a Bridgestone per la preventiva approvazione. Bridgestone avrà il diritto di verificare in qualsiasi momento, mediante un'ispezione in loco presso la sede del Partecipante, il rispetto delle regole di utilizzo dei DPI. Il Partecipante non può in alcun modo cedere l'uso dei DPI e/o disporne in altro modo a terzi.",
    point12Title: "DISPOSIZIONI FINALI",
    point121Desc:
      "Le modifiche o le aggiunte ai presenti termini e condizioni devono essere effettuate per iscritto. Ciò vale anche per la rinuncia al requisito della forma scritta.",
    point122Desc:
      "La legge olandese si applica ad esclusione della Convenzione delle Nazioni Unite sui contratti di vendita internazionale di merci. Per qualsiasi controversia connessa o derivante dalla Lettera di impegno, le Parti scelgono la giurisdizione esclusiva del Tribunale di Rotterdam, Paesi Bassi.",
    point123Desc:
      "Se singole disposizioni delle presenti condizioni generali di contratto dovessero risultare inefficaci o in contrasto con le norme di legge, ciò non pregiudicherà il resto del contratto. La disposizione non valida sarà sostituita di comune accordo dalle parti contraenti con una disposizione che si avvicini maggiormente al senso economico e allo scopo della disposizione non valida in modo giuridicamente efficace.",
    point1234Desc:
      "La suddetta disposizione si applica anche in caso di lacune o omissioni. Gli accordi verbali non sono ritenuti validi e solo le condizioni di partecipazione descritte nelle Condizioni Generali di Contratto (CGC) sono considerate vincolanti.",
    point13Title: "POLITICA DI RESTITUZIONE",
    point13Desc:
      "Il Partecipante ha un diritto di recesso di 14 giorni. <br/>In questo caso, deve scrivere a: Bridgestone CHFope NV/SA Netherlands Branch, con sede legale in Nieuwe Weideweg1 NL- 6121 PD Born Netherlands. Bridgestone fornirà al partecipante le istruzioni necessarie per la procedura di restituzione. Il periodo di restituzione inizia con il ricevimento della merce da parte del Partecipante. In caso di restituzione di un prodotto consegnato, l'acquirente è responsabile della copertura dei costi di restituzione se la merce consegnata corrisponde a quella ordinata. I punti utilizzati dal Partecipante per il premio riscattato saranno reintegrati nel conto punti. Il diritto di restituzione non si applica agli articoli che sono stati personalizzati in base alle specifiche o che sono chiaramente adattati alle esigenze personali.",
  },
  commitmentLetter: {
    title: "Lettera di impegno",
    short_description: "Consulta i nostri dati di contatto e di contatto in.",
  },
  kickbackInfo: {
    title:
      "Spiegazione della commissione kickback per la restituzione dei crediti e dei punti",
    short_description:
      "Qui potete vedere come guadagnare le commissioni di kickback e i punti marketing.",
    description:
      "Con <b>BRIDGESTONE PLUS</b> si guadagnano punti e una commissione di rimborso kickback per tutti i pneumatici Bridgestone ordinati presso i rivenditori designati Bridgestone. Di seguito viene illustrato come guadagnare punti e commissioni di rimborso. <br /><br />&gt;Regole<b>:</b><ul><li>Per ogni pneumatico Bridgestone si ricevono punti marketing da spendere in negozio. Il numero di punti ricevuti per ogni pneumatico dipende dalla dimensione in pollici del pneumatico.</li><li>Lo sconto viene accumulato nel corso dell'anno attraverso gli ordini di pneumatici effettuati presso i rivenditori autorizzati Bridgestone. Bridgestone pagherà il rimborso al partecipante una volta all'anno, dopo aver verificato l'accuratezza dei dati raccolti e a condizione che siano stati acquistati almeno 120 pneumatici all'anno. Il pagamento viene effettuato nel primo trimestre dell'anno successivo. Esempio: la compensazione kickback per l'anno 2024 sarà versata nel primo trimestre del 2025. Questo processo avviene automaticamente dopo la verifica degli ordini di pneumatici e dei vostri dati. Riceverete la compensazione kickback direttamente da Bridgestone o tramite un suo partner esterno. Riceverete anche un documento da inserire nella vostra amministrazione finanziaria.</li></ul>",
    tableFooter:
      "Nessuna commissione kickback per gli altri gruppi di prodotti: TBR, MC, OTR, AG",
    withdraw: "Per l'applicazione di una commissione di rimborso",
  },
  pause: "PAUSA",
  myProfile: "Il mio profilo",
  tyreAmount: "Quantità di pneumatici",
  rewardsOverview: {
    titlePoints: "Punti marketing (1 punto = 0,25 CHF)",
    titleKickback: "Bonus di compensazione kickback in CHF",
    footerPoints:
      "Nessun punto marketing per gli altri gruppi di prodotti: TBR, MC, OTR, AG",
    kickbackPoints:
      "Nessuna commissione kickback per gli altri gruppi di prodotti: TBR, MC, OTR, AG",
    groupLevel: "Livello di gruppo",
  },
  group: "Gruppi",
  major: "Gruppo",
  strategicPartners: {
    cardTitle: "Contatti con i nostri partner strategici",
    title: "Contattare il partner di vendita",
    description:
      "Siamo pronti per voi! Di seguito troverete i dettagli dei vostri contatti con i grossisti.",
    short_desc:
      "Avete domande sui vostri ordini di pneumatici presso i rivenditori affiliati? Cliccate qui sotto per i dettagli di contatto",
  },
  onlineVisibility: {
    box: {
      title: "Visibilità online",
    },
    title: "Visibilità online",
    description:
      "Aumentate e controllate la vostra visibilità digitale a livello di POS con UBERALL",
    category_title: "uberall - migliorare la visibilità digitale",
    category_description:
      "Utilizzate subito i vostri punti premio per portare il vostro marketing digitale di localizzazione al livello successivo. Con l'aiuto della piattaforma uberall, Bridgestone supporta i partner commerciali nell'ottimizzazione della loro presenza online per generare più visitatori. E questo su oltre 100 piattaforme come Google, Facebook, Bing o Trustpilot.",
    content: "Approfittate subito dei vantaggi uberall:",
    point1: "Ottimizzazione della visibilità online",
    point2: "Comoda gestione e controllo delle postazioni POS",
    point3:
      "Tracciare la visibilità locale, le valutazioni e i contenuti dei social media",
    footer:
      "Per informazioni dettagliate e una prima impressione di uberall, guardate il seguente video.",
    period: "Durata: 1 anno",
    form: {
      title: "Come utilizzare uberall per la vostra azienda:",
      point1: "Sottoscrivete un abbonamento annuale per 480 punti",
      point2: "Riceverete una conferma dopo un controllo interno",
      point3: "Nessun rinnovo automatico",
      pointDiscount: "Punti in un {price} CHF di per i seguenti",
      howMuch: "Quanti punti volete utilizzare?",
    },
    uberall: {
      title: "ABBONAMENTO UBERALL",
    },
  },
  media: {
    title: "Pacchetti multimediali",
    short_description:
      "Qui troverete i dati relativi a social media, TV in-store e altro ancora.",
    description:
      "Qui troverete immagini, video e media digitali da utilizzare gratuitamente. Utilizzate i nostri pacchetti multimediali per la vostra presenza sui social media, per le pubblicità televisive o digitali nei negozi.",
  },
  sortBy: {
    default: "Ordina per",
    desc: "Ordina per: Più recente",
    asc: "Ordina per: Più vecchio",
    name: "Namen",
    date: "Datum",
    choiceBy: "Auswahl sortieren nach",
  },
  bridgestoneProductBrochures: {
    title: "Prodotti Bridgestone",
    description:
      "Scaricate qui le brochure e i volantini più recenti sui nostri pneumatici Bridgestone per auto, SUV e furgoni.",
    files: {
      desc1: "Auto, SUV - Inverno",
    },
  },
  testResult: "Risultati del test",
  productOverview: "Panoramica del prodotto",
  summary: "Riassunto",
  information: "Informazioni",
  brochure: "Brochure",
  makeChoice: "Fate la vostra scelta qui",
  winterIn: "L'inverno è arrivato",
  summerIn: "Verso l'estate",
  allSeasonIn: "Per tutta la stagione",
  haveQuestion: "Avete una domanda?",
  contactUs: "Allora inviateci un'e-mail a",
  at: "con",
  tyreBox: {
    title: "Pneumatici",
    totalAmount: "Totale pneumatici",
    target: "Il vostro obiettivo",
    entry: "Il tuo ingresso",
  },
  languageSelect: {
    title:
      "Welcome to <b>BRIDGESTONE PLUS</b> - the premium portal from Bridgestone.",
    label: "Language Selection",
    description:
      "Bitte wählen Sie Ihre Sprache/ Veuillez choisir votre langue/ Selezionare la lingua",
  },
  current_tyres_amount: "Importo del pneumatico",
  current_points: "Punto",
  current_kickbacks: "Kick-back",
  phoneShortCut: "Tel.",
  mediaCategories: {
    products: "Produkte",
    brand_and_solutions: "Marke & Lösungen",
    season_and_promotions: "Saison & Aktionen",
    format: "Format",
    cars_and_vans: "Pkw & Transporter",
    truck_and_buses: "Lkw & Bus",
    motorcycle: "Motorrad",
    agriculture: "Landwirtschaft",
    construction_machinery: "Baumaschinen",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    summer: "Sommer",
    winter: "Winter",
    all_season: "All Season",
    promotions: "Aktionen",
    video_in_store: "Video (Instore)",
    video_online: "Video (Online)",
    banner_website: "Banner (Webseite)",
    banner_social_media: "Banner (Social Media)",
    logos: "Logos",
    b_drive: "B-drive",
    media_library: "Media library",
    media_packages: "Media packages",
  },
  placeholders: {
    searchMedia: "Inserisci un termine di ricerca",
  },
  searchResults: "Risultati di ricerca",
  setFilters: "Bitte setzen Sie Ihre Auswahlfilter",
  kickbackExchange: {
    title: "Scambio di tangenti",
    description:
      "Inserisci l'importo delle commissioni che desideri scambiare<sup>*</sub>:",
    disclaimer: "Livello base: {tyres} pneumatici necessari",
    afterExchange: "Il tuo estratto conto dopo il cambio:",
  },
  productSearchBox: {
    from: "del valore del punto",
    to: "fino al valore del punto",
  },
  validators: {
    min_money: "Field must be greater then {min} €",
    max_money: "Field must be lower then {max} €",
  },
  subMediaPage: {
    description:
      "Benvenuti nell'area media sui prodotti Bridgestone e Firestone. Qui troverete, ad esempio, immagini attuali dei prodotti, loghi nonché numerosi banner, video e modelli digitali utilizzabili. B. sul tuo sito web o sui social media.",
  },
  brochure_prices: {
    description:
      "Scarica qui le brochure, i volantini e i listini prezzi più recenti dei nostri pneumatici Bridgestone e Firestone per auto, SUV e furgoni.",
  },
  brochureCategories: {
    products: "Prodotti",
    brand_and_solutions: "Marchio e soluzioni",
    season_and_promotions: "Stagione e promozioni",
    format: "Formato",
    cars_and_vans: "Auto e veicoli commerciali",
    summer: "Estate",
    winter: "Inverno",
    promotions: "Promozioni",
    all_season: "Quattro stagioni",
    truck_and_buses: "Camion e autobus",
    motorcycle: "Motocicletta",
    agriculture: "Agricoltura",
    construction_machinery: "Macchine da costruzione",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiali",
    brochures: "Brochure",
    price_list: "Listino prezzi",
    materials: "Materiali",
  },
  favoriteProducts: {
    description: "Qui troverai i prodotti che hai salvato.",
  },
  multiplicator: {
    title: "Moltiplicatore bonus",
    bandBonusTitle: "Bonus per pneumatico con moltiplicatore",
    amountLabel: "Numero min. di pneumatici (*)",
    label: "Moltiplicatore bonus",
    desc: "Numero di pneumatici Bridgestone e Firestone. Non è previsto alcun bonus in euro sui pneumatici Firestone.",
    goals: {
      loyal: "Fedele",
      bronze: "Bronzo",
      silver: "Argento",
      gold: "Oro",
      platinum: "Platino",
    },
    andMore: "e oltre",
    chooseTarget: "Seleziona",
    selectTarget: "Seleziona qui il tuo obiettivo annuale {year}:",
    multiplication: "Il bonus viene moltiplicato per <b>{factor}</b>",
    minTyres: "<b>Minimo:</b> {tyre} pneumatici",
  },
  validation: {
    participantCount: {
      max: "{field} può essere al massimo {max}",
    },
    setPoints: {
      max: "Hai a disposizione un totale di {max} punti",
    },
    default: "{field} può essere al massimo {max}",
  },
};
